import React from 'react';
import classes from './NavigationItem.css';
import { NavLink } from 'react-router-dom';

const navigationItem = (props) => (
  <li className="block mt-4 font-serif text-white hover:text-black mr-4 pr-5 lg:border-black lg:border-r-2 lg:last:border-r-0 lg:inline-block lg:mt-0">
    <NavLink
      to={props.link}
      activeClassName={classes.active}
      className="px-2 pt-2 pb-2 block"
      onClick={props.click}>{props.children}</NavLink>
  </li>
);

export default navigationItem;
